import type { FC } from 'react';
import type { RenderImageProps } from 'react-photo-gallery';

import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';

import { Checkmark } from './Checkmark/Checkmark';
import './SelectablePicture.scss';

export const SelectablePicture: FC<RenderImageProps<Custom>> = ({
  index,
  onClick,
  photo,
  margin,
  direction,
  top,
  left,
}) => (
  <div
    key={index}
    style={{
      position: direction === 'column' ? 'absolute' : 'relative',
      top,
      left,
      margin,
      height: photo.height,
      width: photo.width,
    }}
    className={`selectable-image ${
      photo.selected ? 'selectable-image--selected' : ''
    }`}
  >
    {photo.selected && <Checkmark />}
    <PictureComponent
      pictureId={photo.pictureId}
      width={photo.width}
      height={photo.height}
      alt={photo.alt}
      onClick={(event: React.MouseEvent<HTMLImageElement>) =>
        onClick?.(event, { index })
      }
    />
  </div>
);

type Custom = {
  pictureId: string;
  selected: boolean;
};
